var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormikContext } from 'formik';
var FormsContext = React.createContext(undefined);
export var FormsContextProvider = FormsContext.Provider;
export var useFormsContext = function () {
    var formik = React.useContext(FormikContext);
    var forms = React.useContext(FormsContext);
    if (!forms) {
        throw new Error('useFormsContext must be used inside of a component that is a child of the Forms provider');
    }
    return __assign(__assign({}, formik), forms);
};
//# sourceMappingURL=FormsContext.js.map